export default __webpack_public_path__ + "static/media/bloc_blanc_fakechoice_medium.e174a0c5.png";